module.exports = __webpack_public_path__ + "static/media/sync.4212e7bb.svg";